var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({ref:"chart",staticClass:"h-full"},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }